import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface FooterData {
  footer?: {
    about?: string;
    columns?: Array<{
      title?: string;
      links?: Array<{
        label: string;
        url: string;
      }>;
    }>;
    contact?: {
      country?: string;
      phone?: string;
      emails?: string[];
      workingHours?: string;
    };
    social?: {
      facebook?: string;
      zalo?: string;
      linkedin?: string;
      youtube?: string;
    };
    copyright?: string;
    poweredBy?: string;
  };
}

interface FooterContextType {
  footerData: FooterData | null;
}

const FooterContext = createContext<FooterContextType>({ footerData: null });

export const useFooter = () => {
  const context = useContext(FooterContext);
  return context;
};

interface FooterProviderProps {
  children: ReactNode;
  footerData: FooterData | null;
}

export const FooterProvider = ({ children, footerData }: FooterProviderProps) => {
  return (
    <FooterContext.Provider value={{ footerData }}>
      {children}
    </FooterContext.Provider>
  );
};

